import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { PieChart, Pie, ResponsiveContainer, Cell } from 'recharts';
import BlockPlafond from './BlockPlafond';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';


const COLORS = ['#24b7bb', '#006291', '#001248'];//, '#008CAA', '#24B7BB'
const RADIAN = Math.PI / 180;



const renderCustomizedLabel = (props, data) => {

  const { cx, cy, midAngle, innerRadius, outerRadius, percent, index } = props
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * (Math.cos(-midAngle * RADIAN)) + 5;
  const y = cy + radius * (Math.sin(-midAngle * RADIAN));
  const radiusLabel = 25 + innerRadius + (outerRadius - innerRadius);
  // eslint-disable-next-line
  const xlabel = cx + radiusLabel * Math.cos(-midAngle * RADIAN);
  // eslint-disable-next-line
  const ylabel = cy + radiusLabel * Math.sin(-midAngle * RADIAN);
  return (
    <>
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
      <text
        x={xlabel}
        y={ylabel}
        fill={props.fill}
        textAnchor={xlabel > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{fontSize: 8}}
      >
       {data[index].name}
      </text>
    </>
  );
};


class Home extends React.Component {
  state = {
    encoursProduits: [],
    encoursEnseigne: []

  }



  getData(aArray) {
    let i = 0
    let autreValue = 0
    const newArray = []
    aArray.forEach(element => {
      i++;
      if (i <= 4) {
        newArray.push(element)
      } else {
        autreValue += element.value
      }

    })
    if (autreValue !== 0)
      newArray.push({ value: autreValue, name: 'Autres' })

    let sortedarray=[]
    


    return newArray
  }


  render() {
    let dataEnseigne = undefined
    if (this.props.encoursEnseigne !== undefined) {
      dataEnseigne = this.getData(this.props.encoursEnseigne)
    }
    let dataProduit = undefined
    if (this.props.encoursProduits !== undefined) {
      dataProduit = this.getData(this.props.encoursProduits)
    }

    return (

      <div className="section">
        <div className="top-icon-box position-relative">
          <div className="container position-relative">
            <div className="row gy-4">
              <div className="col-xl-12 col-md-12 aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                <div className='HomeBlock'>
                  Dernières Informations

                </div>
              </div>

            </div>
            <div className="row gy-4">

              <div className="col-xl-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                {this.props.encoursEnseigne !== undefined ?
                  <BlockPlafond  {...this.props} />
                  : null
                }
              </div>


              <div className="col-xl-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                <div className='HomeBlock graphic' >
                  <p className='HomeBlockTitle'>- REPARTITION PAR ENSEIGNE -</p><br />
                  {dataEnseigne !== undefined ?
                    <ResponsiveContainer width="100%">
                      <PieChart >
                        <Pie
                          data={dataEnseigne}
                          cx="50%"
                          cy="50%"
                          outerRadius={100}
                          innerRadius={30}
                          
                          fill="#8884d8"
                          dataKey="value"
                          label={(props) => renderCustomizedLabel(props, dataEnseigne)}
                        >
                          {dataEnseigne.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer> :
                    null}
                </div>
              </div>


              <div className="col-xl-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                <div className='HomeBlock  graphic' >
                  <p className='HomeBlockTitle'>- REPARTITION PAR PRODUIT -</p><br />
                  {dataProduit !== undefined ?
                    <ResponsiveContainer width="100%" >
                      <PieChart >
                        <Pie
                          data={dataProduit}
                          cx="50%"
                          cy="50%"
                          outerRadius={100}
                          innerRadius={30}

                          fill="#8884d8"
                          dataKey="value"
                          label={(props) => renderCustomizedLabel(props, dataProduit)}
                        >
                          {dataProduit.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer> :
                    null}
                </div>
              </div>



            </div>

            {(this.props.url === 'btf' && !this.props.parrain.startsWith('SYM')) ?
              <>
                <div className="row gy-4">
                  <div style={{ display: 'block', width: '100%' }}>
                    <div className='titleAvantage' style={{ width: '300px', margin: 'auto', paddingTop: '20px' }}>
                      <b>MES AVANTAGES OFFERTS PAR BTF</b>
                    </div>
                  </div>
                </div>
                <div className="row gy-4">
                  <div className="col-xl-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                    <div className='HomeBlock'  >
                      <Link to='https://adherents.reducbox.com/login' target='_blank' >
                        <img src='/assets/images/Image20240827152813.png' alt='' style={{ width: '100%', height: '100%' }} />
                      </Link>
                      <p>
                        Une plateforme d’avantages pour fidéliser et récompenser vos salariés (cinémas, parcs, sorties culturelles, vacances, achats du quotidien, …)
                      </p>
                    </div>
                  </div>
                  <div className="col-xl-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                    <div className='HomeBlock' >
                      <Link
                        to={"https://reducpro.fr/?token=" + jwtDecode(this.props.JWTToken).ssoreducpro + "&service=sso&pclient=reducpro&pkclient=1D2y4edYet5ddYZedrg1"}
                        target='_blank'
                      >
                        <img src='/assets/images/Design sans titre (67).png' alt='' style={{ width: '100%', height: '100%' }} />
                      </Link>
                      <p>
                        Des avantages professionnels sur divers services et produits essentiels à votre activité (Fournitures, matériaux, intérims…)
                      </p>
                    </div>
                  </div>
                </div>
              </>
              :
              null
            }
          </div>
        </div>
      </div >
    )
  }

}

const mapStateToProps = (state) => {
  return ({
    serverConfigLoaded: state.server.initialized,
    clients: state.authentication.clients,
    currentClient: state.authentication.currentClient,
    JWTToken: state.authentication.JWTToken,
    apiUrl: state.server.apiUrl,
    encoursProduits: state.app.encoursProduits,
    encoursEnseigne: state.app.encoursEnseigne,
    nomCommercial: state.app.nomCommercial,
    telCommercial: state.app.telCommercial,
    plafond: state.app.plafond,
    emailCommercial: state.app.emailCommercial,
    url: state.app.url,
    parrain: state.app.parrain
  })
}

Home.propTypes = {
  dispatch: PropTypes.func,
  clients: PropTypes.array,
  apiUrl: PropTypes.string,
  JWTToken: PropTypes.string,
  currentClient: PropTypes.object,
  encoursProduits: PropTypes.array,
  encoursEnseigne: PropTypes.array,
  nomCommercial: PropTypes.string,
  telCommercial: PropTypes.string,
  plafond: PropTypes.number || PropTypes.string,
  emailCommercial: PropTypes.string,
  url: PropTypes.string,
  parrain: PropTypes.string
};

export default connect(mapStateToProps)(Home);
